import * as echarts from "echarts/core";
import { formatDataUrl } from "./utils";

const PREFECTURE_TILES_GEO_URL = formatDataUrl("/geo/japan-prefectures-tiles.geojson");

const PREFECTURE_BY_CODE: Record<number, string> = {
  1: "北海道",
  2: "青森県",
  3: "岩手県",
  4: "宮城県",
  5: "秋田県",
  6: "山形県",
  7: "福島県",
  8: "茨城県",
  9: "栃木県",
  10: "群馬県",
  11: "埼玉県",
  12: "千葉県",
  13: "東京都",
  14: "神奈川県",
  15: "新潟県",
  16: "富山県",
  17: "石川県",
  18: "福井県",
  19: "山梨県",
  20: "長野県",
  21: "岐阜県",
  22: "静岡県",
  23: "愛知県",
  24: "三重県",
  25: "滋賀県",
  26: "京都府",
  27: "大阪府",
  28: "兵庫県",
  29: "奈良県",
  30: "和歌山県",
  31: "鳥取県",
  32: "島根県",
  33: "岡山県",
  34: "広島県",
  35: "山口県",
  36: "徳島県",
  37: "香川県",
  38: "愛媛県",
  39: "高知県",
  40: "福岡県",
  41: "佐賀県",
  42: "長崎県",
  43: "熊本県",
  44: "大分県",
  45: "宮崎県",
  46: "鹿児島県",
  47: "沖縄県",
};

const PREFECTURE_NAMES = new Set(Object.values(PREFECTURE_BY_CODE));

type GeoJsonFeature = {
  properties?: Record<string, unknown>;
};

type PrefectureGeoJson = {
  type?: string;
  features?: GeoJsonFeature[];
};

type PrefectureMapInput = Parameters<typeof echarts.registerMap>[1];

let prefectureMapPromise: Promise<void> | null = null;

export function normalizePrefectureGeoJson(geoJson: PrefectureGeoJson): PrefectureMapInput {
  for (const feature of geoJson.features ?? []) {
    const properties = feature.properties ?? {};
    const nameCandidate = [properties.nam_ja, properties.N03_001, properties.prefecture, properties.NAME_JA, properties.name].find(
      (value) => typeof value === "string" && PREFECTURE_NAMES.has(value)
    );
    const codeCandidate = Number(properties.id ?? properties.code ?? properties.pref_code);
    const resolvedName = typeof nameCandidate === "string" ? nameCandidate : PREFECTURE_BY_CODE[codeCandidate];

    if (resolvedName) {
      feature.properties = { ...properties, name: resolvedName };
    }
  }

  return geoJson as PrefectureMapInput;
}

export function ensurePrefectureMap() {
  if (!prefectureMapPromise) {
    prefectureMapPromise = fetch(PREFECTURE_TILES_GEO_URL)
      .then((response) => {
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}`);
        }

        return response.json();
      })
      .then((geoJson: PrefectureGeoJson) => {
        echarts.registerMap("japan-prefectures-tiles", normalizePrefectureGeoJson(geoJson));
      });
  }

  return prefectureMapPromise;
}
